let screen_width = $(window).width();
setTimeout(function(){
    if(screen_width > 798){
        $('#mobile-header .mobile-icons').remove();
    }
    let i;
    let len = $(".flickity-page-dots").children().length;
    if(len > 1){
        for (i=1; i<=len; i++) {
            $(".flickity-page-dots .dot:nth-child("+i+")").attr("tabindex","0");
        }
    }   
    $('.announcement-bar-slideshow-with-text__container .text-slideshow').removeAttr('tabindex');
    $(".blog-page .text-slideshow").removeAttr('tabindex');
    $(".blog-page .image-slideshow").removeAttr('tabindex');
    $(".text-slideshow.flickity-enabled").removeAttr('tabindex');
    $(".slider-gallery").removeAttr('tabindex');
    $(".related-products .slider-gallery").removeAttr("tabindex");
    $(".product-template .product-gallery__thumbnails").removeAttr("tabindex");
    $(".shopify-product-form .klaviyo-bis-trigger").attr('role','button');
    $('.tiktok-embed iframe').attr("title","@hellokitty tiktok")
    $(".isp_product_image_wrapper .isp_product_image_href").attr("tabindex","-1");
    $(".isp_product_image_wrapper .isp_product_image").attr("alt","");
    $(".isp_single_facet_wrapper > .isp_facet_value").map(function() {
        let checkbox_title = $(this).children("a").attr("title");
        console.log(checkbox_title)
        $(this).children("a").attr("aria-label","Click here to apply "+ checkbox_title);
    });
    $(".featured-collection-section").map(function() {
      $(this).find(".flickity-prev-next-button.next").attr("aria-label",$(this).find(".featured-collection__title").text().trim()+" Slider Next")
      $(this).find(".flickity-prev-next-button.previous").attr("aria-label",$(this).find(".featured-collection__title").text().trim()+" Slider Previous");
    });
    // $(".custom-options span").first().addClass("first-focusable-cart");
    // $(".custom-options span").last().addClass("last-focusable-cart");
},10000)
$(document).on("keypress", ".blog-category-filter .sidebar-block__heading", function (e) {
    var key = e.which;
    if(key == 13 || key == 32){
        $(this).click();
        let attr = $(this).attr('aria-expanded');
        let newattr = 'true';
        if(attr == 'true'){
            newattr = 'false';
        }
        $(this).attr('aria-expanded', newattr);
    }
});
$(document).on("keypress", ".flickity-page-dots .dot", function (e) {
    var key = e.which;
    if(key == 13 || key == 32){
        $(this).click();
        $(this).parent().siblings('.flickity-viewport').find('.gallery-cell.is-selected:first a').focus();
    }
});
$(document).on("keypress", "#back-to-top", function (e) {
    var key = e.which;
    if(key == 13 || key == 32){
        $(this).click();
    }
});
$(document).on("keypress", ".mobile-menu .close-dropdown", function (e) {
    var key = e.which;
    if(key == 13 || key == 32){
        $(this).click();
        $(this).attr('aria-expanded', function(index, attr){
            return attr == 'true' ? 'false' : 'true';
        });
    }
});
$(document).on("click", ".mobile-menu .close-dropdown", function (e) {
    $(this).attr('aria-expanded', function(index, attr){
        return attr == 'true' ? 'false' : 'true';
    });
});
$(document).on("keypress", ".account_button", function (e) {
    var key = e.which;
    if(key == 13 || key == 32){
        $(this).siblings('ul').toggleClass('acc_show');
    }
});
$(document).on("keypress", ".isp-product-add-to-cart", function (e) {
    var key = e.which;
    if(key == 13 || key == 32){
        $(this).click();
    }
});
$(document).on("keypress", ".sort-by-trigger-container", function (e) {
    var key = e.which;
    if(key == 13 || key == 32){
        $(this).click();
    }
});
$(document).on("keypress", ".isp-sort-option", function (e) {
    var key = e.which;
    if(key == 13 || key == 32){
        $(this).click();
    }
});
$(document).on("keypress", ".back-to-top", function (e) {
    var key = e.which;
    if(key == 13 || key == 32){
        $(this).click();
    }
});
$(document).on("keypress", ".custom-select-trigger", function (e) {
    var key = e.which;
    if(key == 13 || key == 32){
        $(this).click();
    }
});
$(document).on("keypress", ".custom-option", function (e) {
    var key = e.which;
    if(key == 13 || key == 32){
        $(this).click();
    }
});
$(document).on("keypress", ".cart__remove .close", function (e) {
    var key = e.which;
    if(key == 13){
        $(this).click();
    }
});
$(document).on("keypress", ".mobile-menu__toggle-button", function (e) {
    var key = e.which;
    if(key == 13){
        $(this).click();
    }
});
$(document).on("keypress", ".custom-removable-tag", function (e) {
    var key = e.which;
    if(key == 13){
        $(this).click();
    }
});
$(document).on("keypress", ".cart__checkout .button.add_to_cart.checkout", function (e) { 
    e.preventDefault(); 
    var key = e.which;
    if(key == 13 || key == 32){
        window.location.href = "/checkout";
    }
});
 
setTimeout(function(){
    $(document).on("keypress", ".boost-pfs-filter-load-more-button", function (e) {
    var key = e.which;
    if(key == 13){
        $('.loadalert').show();
        setTimeout(function(){
            $('.loadalert').hide();
        },2000);

    }
});
},2000);

document.addEventListener('keydown', function(e) {
    let firstFocusableFilter = document.querySelector('.first-focusable-cart');
    let lastFocusableFilter = document.querySelector('.last-focusable-cart'); 
    if(e.target == firstFocusableFilter && e.key == 'Tab' && e.shiftKey) {
      e.preventDefault();
      lastFocusableFilter.focus();
    } 
    else if(e.target == lastFocusableFilter && e.key == 'Tab' && !e.shiftKey) {
      e.preventDefault();
      firstFocusableFilter.focus();
    }
  });